<!-- <p>cart-buttons works!</p> -->
<div class="cart_butoon_container">

	<ng-container *ngIf="isUserLoggedIn">

		<ng-container *ngIf="nonBulkQty && nonBulkQty>=0">
			<ng-container *ngIf="!isCartDisable">
				<button (click)="addToCartNonBulk()" class="add-to-cart-button {{!productData.volumeDiscountProfileEnabled?'full_width':''}}">
					ADD TO CART
				</button>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="!nonBulkQty || isCartDisable || nonBulkQty<0">
			<button (click)="notifyOutOfStock()" class="{{!productData.volumeDiscountProfileEnabled?'full_width':''}} " >
				<div>NOTIFY ME</div>
				<span class="material-symbols-outlined">
						notification_add
				</span>
			</button>
		</ng-container>


		<button class="preOrder_button" (click)="preOrderTrigger()" *ngIf="productData.volumeDiscountProfileEnabled">
			PRE-ORDER IN BULK
		</button>

	</ng-container>

	<ng-container *ngIf="!isUserLoggedIn">
		<ng-container *ngIf="!(!nonBulkQty || isCartDisable || nonBulkQty<0)">
			<button class="{{!productData.volumeDiscountProfileEnabled?'full_width':''}}" (click)="loginToAddCart()">
				LOGIN TO ADD TO CART
			</button>
		</ng-container>

		<ng-container *ngIf="(!nonBulkQty || isCartDisable || nonBulkQty<0)">
			<button class="{{!productData.volumeDiscountProfileEnabled?'full_width':''}}" (click)="loginToGetNotified()">
				LOGIN TO GET NOTIFIED
			</button>
		</ng-container>

	</ng-container>

	<ng-container *ngIf="!isUserLoggedIn">
	<button class="preOrder_button" routerLink="/auth/login" (click)="loginToAddCart()" *ngIf="productData.volumeDiscountProfileEnabled">
		LOGIN TO PRE-ORDER IN BULK
	</button>
	</ng-container>

</div>
<div class="swatch_cont" *ngIf="isFabricProduct">

	<ng-container *ngIf="isUserLoggedIn">
		<button *ngIf="addToSwatch" (click)="addToCartSwatch()">
			<img src="assets/img/swatch.svg" alt="swatch" />
			<span>
				Order A Swatch
			</span>
		</button>
	</ng-container>

	<ng-container *ngIf="!isUserLoggedIn">
		<button *ngIf="addToSwatch" (click)="loginToAddCart()"
				routerLink="/auth/login">
			<img src="assets/img/swatch.svg" alt="swatch" />
			<span>
				Login to Order A Swatch
			</span>
		</button>
	</ng-container>


	<!-- <button>
		<img src="assets/img/swatch_bundle.svg" />
		<span>
			Order A Swatch Bundle
		</span>
	</button> -->
</div>

<ng-container *ngIf="!isTheOrderInstock && !isCartDisable">
	<div class="estimated" *ngIf="productData.subCategory.madeToOrderProfile || productData.madeToOrderProfileEnabled">
		Made to Order : Estimated Date Of Delivery: {{(fromDays | formatDate).split(',')[0]}} to {{toDays | formatDate}}
	</div>
</ng-container >

